import type { LeadSignalTimelineDto } from '@/api/leads'
import { PersonAvatar } from '@/components/common/Avatar'
import { ExternalIcon } from '@/components/companies/CompanyNameCell'
import { ConsentChip } from '@/components/contacts/contactShared'
import { getLeadDisplayName, shouldShowEmailLine } from '@/utils/leadFormatting'

/**
 * The Lead cell of the campaign, web and workspace Contacts grids, kept as one component because
 * three copies of a cell that grows behaviour drift apart.
 */
export function LeadNameCell({ lead }: { lead: LeadSignalTimelineDto }) {
  const name = getLeadDisplayName(lead)

  return (
    <div class="flex items-center gap-3">
      <PersonAvatar firstName={lead.FirstName} lastName={lead.LastName} fullName={lead.FullName} profilePicUrl={lead.ProfilePicUrl} alt={name} />
      <div class="flex flex-col gap-0.5 leading-tight min-w-0">
        <span class="inline-flex items-center gap-1.5 min-w-0">
          <span class="font-medium text-gray-900 dark:text-gray-100 truncate max-w-[180px]" title={name}>{name}</span>
          {lead.LinkedinProfileUrl && (
            <ExternalIcon href={lead.LinkedinProfileUrl} label={`${name} on LinkedIn`} kind="linkedin" />
          )}
        </span>
        {shouldShowEmailLine(lead, name) && (
          <span class="text-xs text-gray-500 dark:text-gray-400 truncate max-w-[200px]" title={lead.Email ?? undefined}>{lead.Email}</span>
        )}
        {!lead.Email && <span class="text-xs"><ConsentChip state="NoEmail" /></span>}
      </div>
    </div>
  )
}
